import ReactHtmlParser from 'react-html-parser';
import { SalsaCard } from './index.js'
import { useRef, useCallback } from 'react'

function useHookWithRefCallback() {
    const ref = useRef(null)
    const setRef = useCallback(node => {
        if (ref.current) {
            // Make sure to cleanup any events/references added to the last instance
        }

        if (node) {
            // Check if a node is actually passed. Otherwise node would be null.
            // You can now do what you need to, addEventListeners, measure, etc.
            node.firstElementChild.scrollIntoView({ behavior: "smooth" })

        }

        // Save a reference to the node
        ref.current = node
    }, [])
    return [setRef]
}


export function CardCollection(props = {}) {
    const {
        cards = [],
        columns = 3,
        rows = 3,
        page = 1
    } = props;

    const [ref] = useHookWithRefCallback()

    return (
        <div
            className={`grid md:grid-cols-2 lg:grid-cols-${columns} grid-rows-${rows} gap-6`}
        >
            {cards.slice(0, columns * rows * page).map((card, i, list) => (
                <div className="contents"
                    {...page > 1 && i === columns * rows * (page - 1) ? { ref } : {}}>
                    <SalsaCard
                        title={ReactHtmlParser(card.title)}
                        key={card.id}
                        id={card.id}
                        href={card.href}
                        image={card.image}
                        body={ReactHtmlParser(card.body)}
                        eventDetails={card.eventDetails}
                    />
                </div>
            ))}
        </div>


    )
}
export default CardCollection